import {
  Flex, Select, Text, VStack,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useDispatch } from 'react-redux';
import ColorPicker from '../../../ColorPicker/ColorPicker';
import { setBgColor, setBgStyles } from '../../formSlice';
import InputSetting from '../../../InputSetting';

export const borderStyleOptions = [
  { key: 'none', value: 'None' },
  { key: 'solid', value: 'Solid' },
  { key: 'dotted', value: 'Dotted' },
  { key: 'dashed', value: 'Dashed' },
  { key: 'inset', value: 'Inset' },
];

const BackgroundStyles = ({ design }) => {
  const dispatch = useDispatch();

  return (
    <VStack color="gray.600" fontSize="sm" gap="3">
      <Flex justify="space-between" w="100%" alignItems="center">
        <Text>Background color</Text>
        <ColorPicker color={get(design, 'backgroundColor')} onChange={(v) => dispatch(setBgColor(v))} />
      </Flex>
      <Flex justify="space-between" w="100%" alignItems="center">
        <Text>Border</Text>
        <ColorPicker color={get(design, 'background.borderColor')} onChange={(v) => dispatch(setBgStyles({ borderColor: v }))} />
      </Flex>
      <Flex justify="space-between" w="100%" alignItems="center">
        <Text>Border style</Text>
        <Select
          value={get(design, 'background.borderStyle')}
          onChange={(e) => dispatch(setBgStyles({ borderStyle: e.target.value }))}
          w="unset"
        >
          {borderStyleOptions.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
        </Select>
      </Flex>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Border width"
          value={get(design, 'background.borderWidth')}
          onChange={(v) => dispatch(setBgStyles({ borderWidth: v }))}
          regex={/^[0-9]+ ?px$/}
          errorMessage="Width must be in px"
        />
      </Flex>
    </VStack>
  );
};

export default BackgroundStyles;
